import type { JSX } from 'react';

/**
 * Wax-stamp style seal that marks the certificate as referee-verified.
 * Drawn inline so the document prints and scales without external assets.
 */
export function VerifiedSeal(): JSX.Element {
  return (
    <div data-testid="verified-seal" className="flex flex-col items-center gap-1.5">
      <svg
        viewBox="0 0 96 96"
        role="img"
        aria-label="Verified seal"
        className="h-16 w-16 text-primary sm:h-20 sm:w-20"
      >
        <circle
          cx="48"
          cy="48"
          r="45"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          opacity="0.3"
        />
        <circle
          cx="48"
          cy="48"
          r="38"
          fill="none"
          stroke="currentColor"
          strokeWidth="1"
          strokeDasharray="3 5"
          opacity="0.55"
        />
        <circle cx="48" cy="48" r="31" fill="currentColor" opacity="0.08" />
        <path
          d="M34 49l10 10 19-21"
          fill="none"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <span className="text-[0.65rem] font-semibold uppercase tracking-[0.25em] text-primary">
        Verified
      </span>
    </div>
  );
}
